import React, { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';
// import { getUsersByGroup, addAssignmentByItem } from './ItemService'
import { getUsersByGroupAndRole, addAssignmentByItem } from './ItemService';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';
// import Container from 'components/Container';

const ItemUserAssignmentAdd = ({
  //itemName,
  startDate,
  endDate,
  subscriptionid,
  listItemUserAssignments,
}): JSX.Element => {
  const [open, setOpen] = useState(false);
  const [users, setUsers] = useState<any[]>([]);
  //const itemName = itemName;
  //const [description, setDescription] = useState('');
  const status = 'New';

  const { itemid } = useParams();
  const [assignmentName, setAssignmentName] = useState<string | null>(null);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const handleChange = (userId) => {
    setSelectedUserId(userId);
  };

  const handleClickOpen = () => {
    listUsersByGroup();
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
    }
  };

  useEffect(() => {
    listUsersByGroup();
  }, []);

  function listUsersByGroup() {
    getUsersByGroupAndRole('ROLE_USER')
      .then((response) => {
        setUsers(response.data);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      });
  }

  function addItemAssignment(subscriptionid, itemid, selectedUserId) {
    const [id, firstName, lastName] = selectedUserId.split(',');
    const subscriptionId = subscriptionid;
    const name = assignmentName;
    const userId = id;
    const userRole = 'ROLE_USER';
    const assignment = {
      firstName,
      lastName,
      //itemName,
      name,
      status,
      subscriptionId,
      userRole,
      userId,
      startDate,
      endDate,
    };

    addAssignmentByItem(itemid, assignment)
      .then(() => {
        listItemUserAssignments(itemid);
        handleClose(null, null);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      });
  }

  return (
    <div>
      <Button onClick={handleClickOpen}>Add User</Button>
      <Dialog disableEscapeKeyDown open={open}>
        <DialogTitle>Select a User</DialogTitle>
        <DialogContent>
          <Box component="form" sx={{ display: 'flex', flexWrap: 'wrap' }}>
            <TextField
              id="assignment-name"
              label="Enter Action"
              value={assignmentName}
              onChange={(e) => setAssignmentName(e.target.value)}
              variant="outlined"
              sx={{ m: 1, minWidth: 300 }}
            />
            <FormControl sx={{ m: 1, minWidth: 120 }}>
              {/* <InputLabel htmlFor="demo-dialog-native">Name</InputLabel> */}
              <Select
                native
                value={selectedUserId || ''} // Use selectedUserId as the value
                onChange={(e) => handleChange(e.target.value)}
                input={
                  <OutlinedInput label="Select User" id="demo-dialog-native" />
                }
              >
                <option value={''}>Select User</option>
                {users.map((user) => (
                  <option
                    key={user.id}
                    value={`${user.id},${user.firstName},${user.lastName}`}
                  >
                    {user.firstName} {user.lastName}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose(null, null)}>Cancel</Button>
          <Button
            onClick={() =>
              addItemAssignment(subscriptionid, itemid, selectedUserId)
            }
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ItemUserAssignmentAdd;
